/** Static model security / TEE flow explainer (src/assets/documents). */
export const TANUH_MODEL_SECURITY_FLOW_ASSET_URL =
  '/assets/documents/tanuh_flow_fin.html';

export const TANUH_MODEL_SECURITY_FLOW_ROUTE = '/model-security';
